/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Swift_Lion_DozeInputs */

const en_raw_swift_lion_doze = /** @type {(inputs: Raw_Swift_Lion_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results`)
};

const de_raw_swift_lion_doze = /** @type {(inputs: Raw_Swift_Lion_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ergebnis`)
};

/**
* | output |
* | --- |
* | "No results" |
*
* @param {Raw_Swift_Lion_DozeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_swift_lion_doze = /** @type {((inputs?: Raw_Swift_Lion_DozeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Swift_Lion_DozeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_swift_lion_doze(inputs)
	return de_raw_swift_lion_doze(inputs)
});